import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {InteractiveList, InteractiveListProps} from '../interactiveList/interactiveList';

/*
 * Constants.
 */

export const dropdownListVerticalPadding = 8;
export const redesignedDropdownListPadding = 5;

export function getDropdownListVerticalPadding(hasDropdownRedesign: boolean) {
  return hasDropdownRedesign ? redesignedDropdownListPadding : dropdownListVerticalPadding;
}

/*
 * Style.
 */

const StyledMainList = styled(InteractiveList)`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${(p) =>
    p.theme.hasDropdownRedesign
      ? `${redesignedDropdownListPadding}px`
      : `${dropdownListVerticalPadding}px 0`};
  overflow: auto;
  position: relative; /* PB-12793 */
`;

/*
 * Component.
 */

export const DropdownList: FC<PropsWithChildren<InteractiveListProps>> = (props) => (
  <StyledMainList {...props}>{props.children}</StyledMainList>
);
